import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../context/AuthContext';
import { shouldRedirectToExternalSignup } from '../auth/useExternalMsal';
import queryParamsUtils from '../utils/queryParamsUtils';

export const PrivateRoute = ({ children }: any) => {
    const { loggedInUser } = useAuthStore();
    const { hasAuthorizedAppToken } = queryParamsUtils();
    const shouldUseExternalSignup = shouldRedirectToExternalSignup();

    const toComp = () => {
        return !!loggedInUser || hasAuthorizedAppToken();
    };

    if (!toComp()) {
        if (shouldUseExternalSignup) {
            return <Navigate to="/signup" replace />;
        }
        return <Navigate to="/login" replace />;
    }

    return children;
};
